import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Module_delete($id: ID!) {
    Module_delete(id: $id) {
      value
    }
  }
`;

const moduleDelete = async id =>
  // eslint-disable-next-line camelcase
  graphql(mutation, { id }).then(a => a.Module_delete);

export default moduleDelete;
